import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newImporter() {
    let importerDetails = {
      importer_name: $(".importer_name").val(),
      marketer_name: $(".marketer_name").val(),
      address: $(".address").val(),
      city: $(".city").val(),
      country: $(".country").val(),
      email_address: $(".email_address").val(),
      mobile_number: $(".mobile_number").val()
    };
    $(".creatingImporter").hide();
    $(".creatingImporterLoader").show();
    baseurl.post(rt.newImporters, importerDetails).then(res => {
      $(".creatingImporter").show();
      $(".creatingImporterLoader").hide();
      $(".form-control").val("");

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.importerCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //importer exits
        ers.ImporterExists();
      } else if (res.data.code === 404) {
        //error on creating importer
        ers.errorCreatingImporter();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  loadImporter({ commit }) {
    baseurl.get(rt.loadImporters).then(res => {
      $(".importersLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success codes
        commit("STORE_IMPORTERS", res.data.importers);
      } else if (res.data.code === 404) {
        //error on loading importers records
        ers.errorLoadingImporters();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_IMPORTERS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  viewImporter({ commit }, importerId) {
    commit("STORE_IMPORTER_UPDATE", importerId);
    router.push("/updateimporter");
  },

  importerUpdate({ commit }) {
    let importerDetails = {
      id: $(".id").val(),
      importer_name: $(".importer_name").val(),
      marketer_name: $(".marketer_name").val(),
      address: $(".address").val(),
      city: $(".city").val(),
      country: $(".country").val(),
      email_address: $(".email_address").val(),
      mobile_number: $(".mobile_number").val()
    };
    $(".updatingImporter").hide();
    $(".updatingImporterLoader").show();
    baseurl.post(rt.updateImporter, importerDetails).then(res => {
      $(".updatingImporter").show();
      $(".updateImporterLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.importerUpdateSuccess();
        commit("STORE_IMPORTERS", res.data.importers);
        setTimeout(() => {
          router.push("/manageimporters");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating importer record
        ers.errorUpdatingImporter();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/importers/actions.js